import { gql, TypedDocumentNode } from '@common/hooks';

export type ApprovalChainTemplateSelectStepTemplateType = {
  id: string;
  approvalChainApproverTemplates: {
    id: string;
    name: string;
  }[];
};

export type AprovalChainTemplateSelectTemplateType = {
  id: string;
  approvalChainStepTemplates: ApprovalChainTemplateSelectStepTemplateType[];
};

export type ApprovalChainTemplateSelectResponse = {
  currentMembership: {
    id: string;
    canApprovalsBypass: {
      value: boolean;
    };
    canShowSidebarAdminItem: {
      value: boolean;
    };
  };
  approvalChainTemplates: AprovalChainTemplateSelectTemplateType[];
  organizationUnit: {
    id: string;
    preapprovalActions?: string[];
  };
};

type ApprovalChainTemplateSelectVariables = {
  organizationUnitUuid: string;
  actionType: string;
};

export const AprovalChainTemplateSelectQuery: TypedDocumentNode<
  ApprovalChainTemplateSelectResponse,
  ApprovalChainTemplateSelectVariables
> = gql`
  query ApprovalChainTemplateSelectResponse(
    $organizationUnitUuid: ID!
    $actionType: String
  ) {
    approvalChainTemplates(
      organizationUnitUuid: $organizationUnitUuid
      actionType: $actionType
    ) {
      id
      approvalChainStepTemplates {
        id
        approvalChainApproverTemplates {
          id
          name
        }
      }
    }
    organizationUnit(uuid: $organizationUnitUuid) {
      id
      preapprovalActions
    }
  }
`;
